import type { AccountView } from './store';

const STORAGE_KEY = 'sw_return_to';

export function readReturnToFromStorage(): AccountView {
  if (typeof window === 'undefined') return null;
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    return (v as AccountView) || null;
  } catch {
    return null;
  }
}

export function syncReturnToStorage(v: AccountView): void {
  if (typeof window === 'undefined') return;
  try {
    if (v) sessionStorage.setItem(STORAGE_KEY, v);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch { /* ignore */ }
}
